// extracted by mini-css-extract-plugin
module.exports = {"label":"_0fce717cdb--label--22mkY"};